module.exports = __webpack_public_path__ + "img/home_banner_4.52300249.png";